import {
  ChartTooltipTimestampHeader,
  type ChartTooltipElementProps,
} from '@cast/design-system';

import { DASHBOARD_CHART_TIMEZONE } from '../constants/dashboardCharts';

export const DashboardDateChartTooltipHeader = <
  T extends { timestamp: string | number }
>({
  data,
  testId,
}: ChartTooltipElementProps<T>) => (
  <ChartTooltipTimestampHeader
    data={data}
    testId={testId}
    timezone={DASHBOARD_CHART_TIMEZONE}
    hideTime
  />
);
